/**
 * /lp-console: the login and invite pages, then the operations console (src/staging/StagingRoutes.tsx). The new console
 * took over these addresses on 26 Sep 2026 (the staging swap); the old console's layout and sidebar are no longer
 * mounted, and its page addresses either live on in the new console or forward to the page that replaced them.
 */
import { Routes, Route } from "react-router-dom";
import { AuthProvider as AdminAuthProvider } from "./hooks/useAdminAuth";
import AdminLogin from "./pages/admin/AdminLogin";
import InviteSignup from "./pages/admin/InviteSignup";
import { stagingRoutes } from "./staging/StagingRoutes";

export default function AdminRoutes() {
  return (
    <AdminAuthProvider>
      <Routes>
        <Route path="/lp-console/*">
          {/* Public admin routes - NO AUTH REQUIRED */}
          <Route index element={<AdminLogin />} />
          <Route path="login" element={<AdminLogin />} />
          <Route path="invite" element={<InviteSignup />} />
          {stagingRoutes()}
        </Route>
      </Routes>
    </AdminAuthProvider>
  );
}
